const getBoundingClientRect = (node) => {
  var _a;
  if (!node || node.nodeType !== 1)
    return;
  return (_a = node.getBoundingClientRect) == null ? void 0 : _a.call(node);
};
export {
  getBoundingClientRect
};
//# sourceMappingURL=getBoundingClientRect.js.map
